import EventSegmentationFilters from 'automation-ui-enrollment/components/eventEnrollment/steps/EventSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const EventFilterView = ({
  flowObjectTypeId,
  triggers
}) => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "event-enrollment-action-card",
    children: /*#__PURE__*/_jsx(EventSegmentationFilters, {
      value: triggers,
      objectTypeId: flowObjectTypeId,
      readOnly: true,
      strategyOptions: {
        showListMembershipFilterFamily: true
      }
    })
  });
};
export default EventFilterView;